/**
 * Patch vehicle_count / overdue_* on department.department_dealerships for one subdomain.
 * Does not mutate inputs. Unmatched departments keep existing dealership rows.
 */
export function mergeDepartmentCounts(departments, rows, subdomain) {
  const list = Array.isArray(departments) ? departments : [];
  const incoming = Array.isArray(rows) ? rows : [];
  const byDeptId = {};

  incoming.forEach((row) => {
    if (!row || row.subdomain !== subdomain) return;
    byDeptId[row.department_id] = row;
  });

  return list.map((department) => {
    if (!department || typeof department !== 'object') return department;
    const row = byDeptId[department.id];
    const dealerships = Array.isArray(department.department_dealerships)
      ? department.department_dealerships
      : [];

    if (!row) {
      return { ...department, department_dealerships: dealerships.slice() };
    }

    const idx = dealerships.findIndex(d => d && d.subdomain === subdomain);
    let nextDealerships;

    if (idx >= 0) {
      nextDealerships = dealerships.map((d, i) => {
        if (i !== idx) return d;
        const patched = {
          ...d,
          id: row.id != null ? row.id : d.id,
          department_id: row.department_id != null ? row.department_id : d.department_id,
          subdomain,
        };
        if (row.vehicle_count != null) patched.vehicle_count = row.vehicle_count;
        if (row.overdue_1 != null) patched.overdue_1 = row.overdue_1;
        if (row.overdue_2 != null) patched.overdue_2 = row.overdue_2;
        return patched;
      });
    } else {
      const appended = {
        id: row.id,
        department_id: row.department_id,
        subdomain,
      };
      if (row.vehicle_count != null) appended.vehicle_count = row.vehicle_count;
      if (row.overdue_1 != null) appended.overdue_1 = row.overdue_1;
      if (row.overdue_2 != null) appended.overdue_2 = row.overdue_2;
      nextDealerships = dealerships.concat([appended]);
    }

    return { ...department, department_dealerships: nextDealerships };
  });
}
